module.exports = __webpack_public_path__ + "01_long_gold.f53201d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/01_long_gold.png
// module id = QYQl
// module chunks = 0